import { Injectable } from '@angular/core';

/**
 * MetaPixelService — encapsula window.fbq() com tipagem e fallback seguro.
 *
 * Uso:
 *   this.metaPixel.track('CompleteRegistration');
 *   this.metaPixel.track('StartTrial', { currency: 'BRL', value: 0 });
 *
 * Requer que o snippet do Meta Pixel esteja no index.html com fbq('init', '...')
 * Falha silenciosamente se o Pixel não estiver carregado (AdBlocker, etc).
 */
@Injectable({ providedIn: 'root' })
export class MetaPixelService {

  /**
   * Dispara um evento padrão do Meta Pixel.
   * @param eventName Nome do evento (ex: 'CompleteRegistration', 'StartTrial', 'Purchase')
   * @param params Parâmetros opcionais do evento
   */
  track(eventName: string, params?: Record<string, unknown>): void {
    try {
      const fbq = (window as any)['fbq'];
      if (typeof fbq === 'function') {
        if (params) {
          fbq('track', eventName, params);
        } else {
          fbq('track', eventName);
        }
      }
    } catch {
      // Pixel bloqueado ou não carregado — falha silenciosa e não quebra o app
    }
  }
}
